export default "__VITE_ASSET__0c7d4ed0__"